import React, { useState, useEffect } from 'react';
import { Button, Table, Modal, Form, Input, message, Space, Popconfirm } from 'antd';
import { ingredientService } from '../../services/ingredientService';

const IngredientManagement: React.FC = () => {
  const [ingredients, setIngredients] = useState<any[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingIngredient, setEditingIngredient] = useState<any>(null);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchIngredients();
  }, []);

  const fetchIngredients = async () => {
    try {
      const data = await ingredientService.getAllIngredients();
      setIngredients(data);
    } catch (error: any) {
      message.error('Erreur lors de la récupération des ingrédients');
    }
  };

  const handleAddIngredient = () => {
    setEditingIngredient(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleEditIngredient = (ingredient: any) => {
    setEditingIngredient(ingredient);
    form.setFieldsValue({
      name: ingredient.name,
      description: ingredient.description || '',
    });
    setIsModalVisible(true);
  };

  const handleDeleteIngredient = async (id: string) => {
    try {
      // ici tu dois passer ton token si ton backend est protégé
      await ingredientService.deleteIngredient(id, ''); 
      message.success('Ingrédient supprimé avec succès');
      fetchIngredients();
    } catch (error: any) {
      message.error('Erreur lors de la suppression de l’ingrédient');
    }
  };

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingIngredient) {
        await ingredientService.updateIngredient(editingIngredient._id, values, '');
        message.success('Ingrédient mis à jour avec succès');
      } else {
        await ingredientService.createIngredient(values, '');
        message.success('Ingrédient créé avec succès');
      }
      setIsModalVisible(false);
      fetchIngredients();
    } catch (error: any) {
      message.error('Erreur lors de la sauvegarde de l’ingrédient');
    }
  };

  const columns = [
    { title: 'Nom', dataIndex: 'name', key: 'name' },
    { title: 'Description', dataIndex: 'description', key: 'description' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: any) => (
        <Space>
          <Button type="link" onClick={() => handleEditIngredient(record)}>Modifier</Button>
          <Popconfirm
            title="Supprimer cet ingrédient ?"
            description="Cette action est définitive."
            okText="Supprimer"
            cancelText="Annuler"
            okButtonProps={{ danger: true }}
            onConfirm={() => handleDeleteIngredient(record._id)}
          >
            <Button type="link" danger>Supprimer</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Button type="primary" onClick={handleAddIngredient} style={{ marginBottom: 16 }}>
        Ajouter un ingrédient
      </Button>
      <Table dataSource={ingredients} columns={columns} rowKey="_id" />

      <Modal
        title={editingIngredient ? 'Modifier l’ingrédient' : 'Ajouter un ingrédient'}
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={() => setIsModalVisible(false)}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Nom"
            rules={[{ required: true, message: 'Veuillez entrer le nom de l’ingrédient' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="Description"
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default IngredientManagement;
